import { table } from './_table';
import { buy } from './buy';

export const numbers = {
  namespaced: true,
  modules: {
    table,
    buy
  }
};
